import axios from 'axios';
import * as Location from 'expo-location';
import { useEffect, useState } from 'react';
import { Platform } from 'react-native';

import { safeJsonParse } from '@/utils/jsonParse';

const useGetLocation = () => {
  const API_KEY =
    Platform.OS === 'web' ? process.env.EXPO_PUBLIC_GOOGLE_MAPS_API_KEY : process.env.EXPO_PUBLIC_GOOGLE_API_KEY_IOS;

  const [location, setLocation] = useState<{ latitude: number; longitude: number } | null>(null);
  const [isFetching, setIsFetching] = useState<boolean>(false);

  const getLocation = async () => {
    try {
      const { granted } = await Location.getForegroundPermissionsAsync();
      if (granted) {
        const lastKnownPosition = await Location.getLastKnownPositionAsync();
        if (!lastKnownPosition) {
          return;
        }
        const { latitude, longitude } = lastKnownPosition.coords;
        setLocation({ latitude, longitude });
        return;
      } else {
        if (!isFetching) {
          setIsFetching(true);

          const url = `https://www.googleapis.com/geolocation/v1/geolocate?key=${API_KEY}`;

          const response = await axios.post(
            url,
            {
              considerIp: true
            },
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          );

          const parsedLocation = safeJsonParse<{ accuracy: number; location: { lat: number; lng: number } }>(
            JSON.stringify(response.data)
          );

          if (parsedLocation) {
            setLocation({ latitude: parsedLocation?.location.lat, longitude: parsedLocation?.location.lng });
            setIsFetching(false);
          }
          return;
        }
      }
    } catch (error: any) {
      setIsFetching(false);
      console.warn('Error while getting location: ', error);
      return;
    }
  };

  useEffect(() => {
    getLocation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return location;
};

export default useGetLocation;
